import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const FileDownloadIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M12 10.0003V12.0003H4.00002V10.0003H2.66669V12.0003C2.66669 12.7337 3.26669 13.3337 4.00002 13.3337H12C12.7334 13.3337 13.3334 12.7337 13.3334 12.0003V10.0003H12ZM11.3334 7.33366L10.3934 6.39366L8.66669 8.11366V2.66699H7.33335V8.11366L5.60669 6.39366L4.66669 7.33366L8.00002 10.667L11.3334 7.33366Z" />
  </Icon>
);

export default memo(FileDownloadIcon);
